import React, { useCallback, useEffect } from 'react';
import 'App.css';
import { Router, Switch, Route, Redirect } from 'react-router-dom';
import MainPage from 'pages/MainPage';
import ThemeContextProvider from 'contexts/theme/Theme';
import LoginPage from 'pages/LoginPage';
import { history } from 'store/helpers';
import { useDispatch, useSelector } from 'react-redux';
import { alertsActions, userActions } from 'store/actions';
import { PrivateRoute } from 'components';
import PageNotFound from 'pages/PageNotFound';
import WorkdeskPage from 'pages/WorkdeskPage';
import { authSelector } from 'store/selectors/user.selector';
import { webSocketActions } from 'store/actions/websocket.actions';
import DashboardPage from 'pages/DashboardPage';
import { useWebSocketSelector } from 'store/selectors/websocket.selector';

const App = () => {
  const dispatch = useDispatch();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const stableDispatch = useCallback(dispatch, []);
  const { loggedIn } = useSelector(authSelector);
  const useWebSocket = useSelector(useWebSocketSelector);

  useEffect(() => {
    if (!process.env.REACT_APP_WS_HOST)
      throw Error(`process.env.REACT_APP_WS_HOST is missing`);

    history.listen((location, action) => {
      // clear alert on location change
      stableDispatch(alertsActions.clearAll());
    });
    stableDispatch(userActions.reviveUserFromLocalStorage());
  }, [stableDispatch]);

  useEffect(() => {
    console.debug(
      `App loggedIn changed: `,
      loggedIn,
      'will connect or disconnect websocket',
    );
    if (loggedIn) {
      stableDispatch(
        webSocketActions.reviveUseWebsocketFromLocalStorage(),
      );
    } else {
      stableDispatch(
        webSocketActions.clearUseWebsocketFromLocalStorage(),
      );
    }
  }, [loggedIn, stableDispatch]);
  useEffect(() => {
    console.debug(`App useWebSocket changed`, useWebSocket);
    if (useWebSocket) {
      console.debug(`call dispatch wsConnect`);
      stableDispatch(webSocketActions.wsConnect());
    } else {
      console.debug(`call dispatch wsDisconnect`);
      stableDispatch(webSocketActions.wsDisconnect());
    }
  }, [useWebSocket, stableDispatch]);

  return (
    <ThemeContextProvider>
      <Router history={history}>
        <Switch>
          <PrivateRoute exact path="/" component={WorkdeskPage} />
          {/* must not use PrivateRoute with /login */}
          <Route path="/login" component={LoginPage} />
          <PrivateRoute path="/main/:ticketId" component={MainPage} />
          <PrivateRoute path="/workdesk" component={WorkdeskPage} />
          <PrivateRoute
            path="/dashboard/:boardType"
            component={DashboardPage}
          />
          <PrivateRoute path="/404" component={PageNotFound} />
          <Redirect from="/history" to="/login?fromAddon=true" />
          <Redirect from="*" to="/" />
          {/* add other routes here */}
        </Switch>
      </Router>
    </ThemeContextProvider>
  );
};

export default App;
